export default {
  root: ({ props }) => ({
    class: [
      'inline-flex relative',
      { '[&>input]:pr-10': props.toggleMask },
      'w-full',
    ],
  }),
  overlay: ({ attrs, parent }) => {
    return {
      class: [
        // Shape
        'shadow-md rounded-lg',

        // Colors
        'bg-base',
        'text-base',
        'stacked-border',

        // Visibility
        {
          hidden:
            attrs['form-title'] === 'login' ||
            parent.attrs.id === 'passwordConfirmation-label',
        },
      ],
    };
  },
  meter: {
    class: [
      // Position and Overflow
      'overflow-hidden',
      'relative',

      // Shape and Size
      'border-0',
      'h-2',
      'rounded-md',

      // Spacing
      'm-2',

      // Colors
      'bg-layer-secondary',
    ],
  },
  meterText: { class: ['hidden'] },
  meterlabel: ({ instance }) => ({
    class: [
      // Size
      'h-full rounded-md stacked-border',

      // Colors
      {
        'bg-error-500': instance?.meter?.strength === 'weak',
        'bg-warning-500': instance?.meter?.strength === 'medium',
        'bg-primary-blue-500': instance?.meter?.strength === 'strong',
      },

      // Transitions
      'transition-all duration-1000 ease-in-out',
    ],
  }),
  maskIcon: {
    class: [
      'absolute top-[47%] right-3 -mt-2 z-10 h-5 w-5',
      'text-base-priority',
    ],
  },
  unmaskIcon: {
    class: [
      'absolute top-[47%] right-3 -mt-2 z-10 h-5 w-5',
      'text-base-priority',
    ],
  },
  pcInputText: {
    root: ({ props, parent, context, instance }) => {
      return {
        class: [
          // Font
          'leading-none',
          'text-sm',
          // Flex
          { 'flex-1 w-[1%]': parent.instance.$name === 'InputGroup' },

          // Spacing
          'm-0',
          {
            'py-4 px-3.5': props.size === 'large',
            'py-1.5 px-2': props.size === 'small',
            'py-3.5 px-3': props.size === null,
            'pt-5 pb-2': props.size === null && !!instance.$data.d_value,
          },

          // Shape
          { 'rounded-lg': parent.instance.$name !== 'InputGroup' },
          {
            'first:rounded-l-md rounded-none last:rounded-r-md':
              parent.instance.$name === 'InputGroup',
          },
          {
            'border-0 border-y border-l last:border-r':
              parent.instance.$name === 'InputGroup',
          },
          {
            'first:ml-0 -ml-px':
              parent.instance.$name === 'InputGroup' && !props.showButtons,
          },

          // Colors
          'text-base-priority',
          'placeholder:text-base-priority/6 dark:placeholder:text-light-50/80',
          { 'bg-base': !props.disabled },
          'border',
          { 'stacked-border': !props.invalid },

          // Invalid State
          { 'invalid:focus:border-error-500': !!context.filled },
          { 'border-error-500 dark:border-error-500': !!props.invalid },

          // States
          {
            'focus:outline-none focus:outline-offset-0 focus:border-1 focus:border-primary-blue-500 dark:focus:border-blue-primary-400 ':
              !props.disabled && !props.invalid,
          },
          'focus:outline-none focus:outline-offset-0',

          // Filled State *for FloatLabel
          {
            filled:
              parent.instance?.$parentInstance?.$name === 'FloatLabel' &&
              parent.props.modelValue !== null &&
              parent.props.modelValue?.length !== 0,
          },

          // Misc
          'appearance-none',
          'transition-colors duration-200',
          'w-full',
        ],
      };
    },
  },
  transition: {
    enterFromClass: 'opacity-0 scale-y-[0.8]',
    enterActiveClass:
      'transition-[transform,opacity] duration-[120ms] ease-[cubic-bezier(0,0,0.2,1)]',
    leaveActiveClass: 'transition-opacity duration-100 ease-linear',
    leaveToClass: 'opacity-0',
  },
};
